/* Spectra Luxe — scroll reveals, stat counters, best-seller tabs */
(function () {
  'use strict';

  // White-background removal: flood-fill near-white pixels connected to the
  // image border to transparent, so product shots on white float on the dark
  // theme background. Interior whites (white packaging) are preserved unless
  // directly connected to the background.
  // Only pure studio-white counts as background, so white products
  // (which carry subtle shading) survive the flood fill.
  function isBg(d, i) {
    return d[i] >= 250 && d[i + 1] >= 250 && d[i + 2] >= 250;
  }
  function cutout(img) {
    if (img.dataset.sxCut) return;
    img.dataset.sxCut = '1';
    var run = function () {
      try {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) return;
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0);
        var id = ctx.getImageData(0, 0, w, h), d = id.data;
        var seen = new Uint8Array(w * h);
        var stack = [];
        var x, y, p;
        for (x = 0; x < w; x++) { stack.push(x); stack.push(x + (h - 1) * w); }
        for (y = 0; y < h; y++) { stack.push(y * w); stack.push(w - 1 + y * w); }
        while (stack.length) {
          p = stack.pop();
          if (seen[p]) continue;
          seen[p] = 1;
          if (!isBg(d, p * 4)) continue;
          d[p * 4 + 3] = 0;
          x = p % w; y = (p / w) | 0;
          if (x > 0) stack.push(p - 1);
          if (x < w - 1) stack.push(p + 1);
          if (y > 0) stack.push(p - w);
          if (y < h - 1) stack.push(p + w);
        }
        // soften edges: any opaque pixel adjacent to a removed one gets partial alpha
        var d2 = new Uint8ClampedArray(d);
        for (y = 1; y < h - 1; y++) {
          for (x = 1; x < w - 1; x++) {
            p = y * w + x;
            if (d[p * 4 + 3] === 0) continue;
            if (d[(p - 1) * 4 + 3] === 0 || d[(p + 1) * 4 + 3] === 0 || d[(p - w) * 4 + 3] === 0 || d[(p + w) * 4 + 3] === 0) {
              d2[p * 4 + 3] = 140;
            }
          }
        }
        id.data.set(d2);
        ctx.putImageData(id, 0, 0);
        img.src = c.toDataURL('image/png');
        img.srcset = '';
        img.classList.add('sx-cut-done');
      } catch (e) { /* tainted canvas or decode failure — keep original */ }
    };
    if (img.complete && img.naturalWidth) run();
    else img.addEventListener('load', run, { once: true });
  }
  function initCutouts(root) {
    (root || document).querySelectorAll('img.sx-cutout').forEach(function (img) {
      if (!img.crossOrigin) img.crossOrigin = 'anonymous';
      if (img.complete && img.naturalWidth && !img.dataset.sxCut) {
        // reload with crossOrigin so canvas isn't tainted
        var src = img.src; img.src = ''; img.src = src;
      }
      cutout(img);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCutouts(); });
  } else {
    initCutouts();
  }
  document.addEventListener('shopify:section:load', function (e) { initCutouts(e.target); });

  // Hero background video — tap to unmute
  document.querySelectorAll('[data-sx-hero-sound]').forEach(function (btn) {
    var hero = btn.closest('.sx-hero');
    var video = hero && hero.querySelector('.sx-hero__bg');
    if (!video) { btn.style.display = 'none'; return; }
    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      var on = !video.muted;
      btn.classList.toggle('is-unmuted', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
      if (on) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });

  // PDP description — Read more / Read less
  document.querySelectorAll('[data-sx-readmore]').forEach(function (wrap) {
    var desc = wrap.querySelector('.sx-pdp-desc, .sx-coll-desc');
    var btn = wrap.querySelector('[data-sx-readmore-btn]');
    if (!desc || !btn) return;
    wrap.classList.add('is-collapsed');
    // only show the toggle if the clamped text is actually overflowing
    if (desc.scrollHeight - desc.clientHeight < 4) {
      wrap.classList.remove('is-collapsed');
      return;
    }
    btn.style.display = 'inline-block';
    btn.addEventListener('click', function () {
      var collapsed = wrap.classList.toggle('is-collapsed');
      btn.textContent = collapsed ? 'Read more' : 'Read less';
    });
  });

  // Scroll reveal
  var reveals = document.querySelectorAll('.sx-reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sx-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('sx-in'); });
  }

  // Count-up stats: <span class="sx-counter" data-target="10000" data-prefix="" data-suffix="+">
  function animateCounter(el) {
    var target = parseFloat(el.dataset.target || '0');
    var decimals = (el.dataset.target || '').includes('.') ? 1 : 0;
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var dur = 1600;
    var start = null;
    function fmt(n) {
      return prefix + n.toLocaleString('en-GB', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + suffix;
    }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('.sx-counter');
  if ('IntersectionObserver' in window && counters.length) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animateCounter(e.target);
          cio.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { cio.observe(el); });
  }

  // Best sellers tab filtering
  document.querySelectorAll('[data-sx-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-sx-tab]');
    var panels = root.querySelectorAll('[data-sx-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        var key = tab.getAttribute('data-sx-tab');
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-sx-panel') !== key;
        });
      });
    });
  });
})();
